<template>
    <div class="box">
        <div class="banner-box" id="banner-h" :isBanner="true" :style="`background-image: url(${Banner});`">
            <p class="big-font">技术前沿、互动体验、资源共享</p>
            <div class="big-font">
                <span class="front">走进虚仿，</span>
                <span class="after">让知识更直观，让学习更有趣</span>
            </div>
        </div>
        <div class="show-resource-box home-Progressive-hidden">
            <div class="show-top-box">
                <div class="left-show">
                    <div class="zd-title">海量虚仿资源</div>
                    <div class="zd-text">
                        <div>
                            <p class="spot"></p>
                            专业动画&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;高度还原&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;创新知识表达；
                        </div>
                        <div>
                            <p class="spot"></p>
                            精细模型&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;真实质感&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;展示细微构造；
                        </div>
                        <div>
                            <p class="spot"></p>
                            超清影像&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;生动再现&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;汇聚精彩内容；
                        </div>
                        <div>
                            <p class="spot"></p>
                            虚仿实训&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;多维互动&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;共建学习空间；
                        </div>
                        <div>
                            <p class="spot"></p>
                            互动课件&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;按需设计&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;构建特色课堂；
                        </div>
                        <div>
                            <p class="spot"></p>
                            高清图片&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;细节尽显&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;还原现场瞬间；
                        </div>
                    </div>
                </div>
                <div class="resource-box">
                    <div v-for="(item, index) in resourceNum" class="resource-item" :key="index">
                        <img :src="item.img" alt="">
                        <div>{{ index }}</div>
                        <countTo :startVal="0" :endVal="item.number" :duration="3000"></countTo>
                    </div>
                </div>
            </div>
        </div>
        <div class="show-video-box home-Progressive-hidden">
            <div class="cover-box">
                <div v-for="(item, index) in coverData" class="cover-item" @click="changeVideo(item,index)" :key="index">
                    <img :src="item.coverImageUrl?$severUrl(item.coverImageUrl):$filterResDefault(item.classifyCode)" style="object-fit: cover;" class="img" alt="">
                    <div class="item-text">
                        <el-tooltip class="item" effect="dark" :content="item.courseName" placement="top-start">
                            <p class="overflow">{{ item.courseName }}</p>
                        </el-tooltip>
                        <el-tooltip class="item" :disabled="!item.info" effect="dark" :content="item.info" placement="top-start">
                            <p class="overflow" style="max-width: 100%;" @click.stop="toDetail(item)">{{ (item.info||'') + '>>' }}</p>
                        </el-tooltip>
                    </div>
                    <div class="border-active" :class="{ 'active-b': currentIndex == index }"></div>
                </div>
            </div>
            <div class="web-page">
                <video controls autoplay muted id="audio"></video>
            </div>
        </div>
    </div>
</template>

<script>
import { GetResDataCount,GetHomeHeatCourse } from '@/api/home';
import Banner from '../../assets/image/home/big-banner.png';
import CountTo from 'vue-count-to';
import Hls from 'hls.js';
export default {
    components: { CountTo },
    data() {
        return {
            bannerUrl: '',
            Banner,
            resourceNum: {
                '动画': {
                    number: 0,
                    img: require('../../assets/image/home/carton.png')
                },
                '模型': {
                    number: 0,
                    img: require('../../assets/image/home/model.png')
                },
                '视频': {
                    number: 0,
                    img: require('../../assets/image/home/video.png')
                },
                '软件': {
                    number: 0,
                    img: require('../../assets/image/home/img.png')
                },
                '课件': {
                    number: 0,
                    img: require('../../assets/image/home/courseware.png')
                },
                '图片': {
                    number: 0,
                    img: require('../../assets/image/home/img.png')
                },
            },
            /**当前展示封面网页 */
            webCover: '',
            coverData: [],
            currentIndex: ''
        }
    },
    methods: {
        /**切换视频 */
        changeVideo(item,index){
            this.currentIndex=index;
            this.playVideo(item.courseVideoUrl);
        },
        /**获取资源数量 */
        getResDataCount() {
            GetResDataCount().then(res => {
                if (res.code == 200) {
                    res.data.forEach(item => {
                        if (item.resType == 'ppt') {
                            this.resourceNum['课件'].number = item.count;
                        } else if(item.resType == 'software'){
                            this.resourceNum['软件'].number = item.count;
                        }else {
                            if (this.resourceNum[item.resType]) {
                                this.resourceNum[item.resType].number = item.count;
                            }
                        }
                    })
                }
            })
        },
        /**获取首页视频资源 */
        getResData() {
            GetHomeHeatCourse().then(res => {
                if (res.code == 200) {
                    this.coverData = res.data;
                    if(res.data&&res.data.length>0){
                        this.changeVideo(res.data[0],0)
                    }
                }
            })
        },
        /**查看热门课程详情 */
        toDetail(item){
            this.$router.push({
                    path:'/course/courseDetail',
                    query: { id: item.id }
                });
        },
        /**播放视频 */
        playVideo(url) {
            const audio = document.getElementById("audio");
            const hls = new Hls();
            if (Hls.isSupported()) {
                hls.loadSource(this.$severUrl(url));
                hls.attachMedia(audio);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    audio.play();
                });
            } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
                audio.src = url;
                audio.addEventListener("canplay", function () {
                    audio.play();
                });
            } else {
                console.error("HLS is not supported in this browser");
            }
        },
    },
}
</script>

<style lang="less" scoped>
.banner-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(../../assets/image/home/big-banner.png);
    background-size: cover;
    white-space: var(--lineWrap);
    padding: 10rem 0;
    min-height: 100rem;
    .big-font{
        padding: 0 5rem;
    }
    &> :nth-child(1) {
        font-size: 9rem;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        color: #ffffff;
        text-shadow: 2px 2px 2px #0b77ff;
    }

    &> :nth-child(2) {
        font-size: 5.4rem;
        letter-spacing: 0.65rem;
        margin-top: 7rem;
    }

    .front {
        color: #0b78ff;
    }

    .after {
        color: #ffffff;
    }
}

.show-resource-box {
    padding: 0 var(--padding);
    width: 100%;
    background-image: url(../../assets/image/home/b-001.png);
    height: 62rem;

    .show-top-box {
        background-image: url(../../assets/image/home/frame.png);
        background-repeat: no-repeat;
        height: 56rem;
        padding: 0 6rem;
        transform: translateY(-9rem);
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        background-size: 100% 100%;
        .left-show {
            color: #ffffff;
            font-size: 16px;
            display: flex;
            flex-direction: column;
            width: 38%;

            .zd-title {
                font-size: 3.6rem;
                text-align: center;
            }

            .zd-text {
                margin-top: 3rem;
                margin-bottom: 4.8rem;
                line-height: 3rem;
                white-space: nowrap;

                &> :nth-child(n) {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
}

.resource-box {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    margin-left: 7rem;
    gap: 3rem;
}

.resource-item {
    height: 20rem;
    width: calc(33% - 3rem);
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
        width: 4.7rem;
        object-fit: cover;
    }

    &> :nth-child(2) {
        color: #0067FF;
        font-size: 1.5rem;
        margin-top: 1rem;
    }

    &> :nth-child(3) {
        color: #0067FF;
        font-weight: 700;
        font-size: 3.6rem;
        font-family: REGULAR, sans-serif;
    }
}

.person-box {
    padding: 6rem 9.5rem;
    overflow: hidden;
    box-shadow: 3.46px 2px 16px 4px #dedede;
    background-color: #ffffff;
    margin-top: 4rem;
    margin-bottom: 14.5rem;
    display: flex;
    justify-content: space-between;
    text-align: center;

    .p-num {
        color: #151C34;
        font-weight: 700;
        font-size: 3.6rem;
    }

    .p-name {
        color: #9BA0B0;
        margin-top: 1rem;
        font-size: 16px;
    }
}

.show-video-box {
    background-image: url(../../assets/image/home/bg-002.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 12rem var(--padding) 12rem var(--padding);
    display: flex;
    align-items: center;
    .cover-box {
        max-height: 64rem;
        overflow: auto;
        border-top: 1px solid #ffffff;
        width: 41rem;

        .cover-item {
            display: flex;
            align-items: center;
            padding: 3rem 0;
            border-bottom: 1px solid #ffffff;
            cursor: pointer;
            width: 100%;
            transition: all 0.3s;
            position: relative;

            img {
                padding: 1rem 1rem 0 1rem;
                background-color: #0067FF;
                width: 13rem;
                height: 8rem;
                border-radius: 5px;
                transition: all 0.3s;
            }

            .item-text {
                margin-left: 2.5rem;
                width: calc(100% - 17.5rem);
                &> :nth-child(1) {
                    color: #151C34;
                    font-size: 2rem;
                    font-weight: 700;
                    width: 100%;
                }
                &> :nth-child(2) {
                    color: #9BA0B0;
                    font-size: 16px;
                    margin-top: 1.3rem;
                    white-space: var(--lineWrap);
                    display: inline-block;
                }
            }
        }
    }
    .web-page {
        width: calc(100% - 46.5rem);
        aspect-ratio: 888/566;
        background-color: #0b77ff;
        margin-left: 5.5rem;
        background-image: url('../../assets/image/home/web.png');
        background-size: 100% 100%;
        padding: 5rem 1rem 1rem 1rem;
        video {
            width: 100%;
            height: 100%;
        }
    }
}
.cover-item:hover {
    transform: translateY(-1rem);
}
.border-active {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 10rem;
    border-radius: 10px;
    background-color: #0067FF;
    opacity: 0;
    transition: all 0.3s;
}
.active-b {
    opacity: 1;
}
.spot {
    width: 3px;
    height: 3px;
    background-color: #ffffff;
    border-radius: 50%;
    margin-right: 2.5rem;
}
@media screen and (max-width:750px) {
    .resource-box{
        margin-left: 0;
        justify-content: space-between;
    }
    .resource-box{
        &> :nth-child(3n+1){
            margin-left: 0;
        }
    }
    .resource-item{
        padding: 2rem;
        height: auto !important;
        width: calc(33% - 2rem);
    }
    .zd-text{
        &> :nth-child(n){
            display: flex;
            justify-content: center;
        }
    }
    .big-font{
        padding: 0 var(--padding) !important;
    }
    .show-video-box{
        flex-direction: column;
        background-image: url(../../assets/image/phone/04.png) !important;
    }
    .web-page{
        margin-left: 0 !important;
        width: 100% !important;
        height: auto !important;
        margin-top: 4rem;
    }
    .cover-box{
        width: 100% !important;
    }
    .banner-box{
        background-image:url(../../assets/image/phone/01.png);
        min-height: auto !important;
        aspect-ratio:1;
        &> :nth-child(1){
            font-size: var(--bigTitle) !important;
        }
        &> :nth-child(2){
            font-size: var(--smallTitle) !important;
            margin-top: 2rem;
        }
    }
    .spot{
        margin-right: 1rem;
    }
    .show-top-box{
        padding:6rem 3rem !important;
        background-image: url(../../assets/image/phone/02.png) !important;
    }
}
@media screen and (max-width:1000px) and (min-width: 751px){
    .show-top-box{
        padding:6rem !important;
    }
}
@media screen and (max-width:1000px){
    .show-resource-box{
        height: auto !important;
        background-image: url(../../assets/image/phone/03.png) !important;
    }
    .left-show{
        align-items: center;
    }
    .show-top-box{
        flex-direction: column;
        height: auto !important;
        &> :nth-child(n){
            width: 100% !important;
        }
        .resource-box{
            margin-left: 0;
            justify-content: space-between;
            &> :nth-child(3n+1){
                margin-left: 0;
            }
        }
    }
}
</style>